import { css, jsx } from '@emotion/core';
import { Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '@/styles';
import { detectEdgeHtml, isMobileSafari, isSafari } from '@/utils/detectBrowser';
import { getFileIcon } from '@/utils/utils';

const style = {
  attch: {
    link: css`
      color: ${colors.secondaryBlue} !important;
      display: flex !important;
      align-items: center;
      margin: -16px -32px !important;
      padding: 16px 32px;
    `,
    icon: css`
      font-size: 2.4rem;
      margin-right: 12px;
      color: ${colors.secondaryBlue} !important;
    `,
  },
};

export const handleDownloadIEAttach = (e, attachBlob, attachFileName) => {
  if (e && e.preventDefault) {
    e.preventDefault();
  }
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(attachBlob, attachFileName);
  }
};

const AttachmentLink = ({
  linkStyle,
  linkText,
  iconStyle,
  iconType,
  theme = 'filled',
  attch,
  noicon,
  download,
}) => {
  const fileExt = /(?:\.([^.]+))?$/.exec(attch.FileName)[1];
  // const isIcs = fileExt === 'ics' || iconType === 'schedule';
  const iSafari = isSafari(); // && !isIcs;
  const ieOrSafari = attch.blob || iSafari;

  const handleClick = () => {
    // TODO: fix attachments to take in blobs again
    // window.open(attch.href, '_blank');
    const link = document.createElement('a');
    // eslint-disable-next-line prefer-destructuring
    link.href = attch.href;
    link.download = attch.FileName;
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(attch.href);
    }, 100);
  };

  const linkProps = { target: '_blank', rel: 'noopener noreferrer' };

  const attchProps = ieOrSafari ? { onClick: handleClick } : { href: attch.href, ...linkProps };

  return (
    <a title={attch.FileName} css={linkStyle || style.attch.link} {...attchProps}>
      {!noicon && (
        <Icon
          type={iconType || getFileIcon(fileExt)}
          theme={theme}
          css={iconStyle || style.attch.icon}
        />
      )}
      <span>{linkText || attch.FileName}</span>
    </a>
  );
};

AttachmentLink.propTypes = {
  attch: PropTypes.object.isRequired,
};

export default AttachmentLink;
